import { useCallback, useRef } from 'react';
import { flushSync } from 'react-dom';

interface ViewTransitionOptions {
  skipTransition?: boolean;
}

export function useViewTransition() {
  const isTransitioning = useRef(false);

  const startTransition = useCallback(
    (callback: () => void, options?: ViewTransitionOptions) => {
      if (options?.skipTransition || !document.startViewTransition || isTransitioning.current) {
        callback();
        return;
      }

      isTransitioning.current = true;

      const transition = document.startViewTransition(() => {
        // flushSync forces React to update DOM synchronously
        // This is required for View Transitions to capture the new state
        flushSync(() => {
          callback();
        });
      });

      transition.finished.finally(() => {
        isTransitioning.current = false;
      });
    },
    []
  );

  return { startTransition, isTransitioning: isTransitioning.current };
}
